module.exports = __webpack_public_path__ + "static/img/banner.8a264c72.png";